import React from "react";
import "./thankyou-modal.m.css";
import { CloseIcon } from "../../../arrow/components/Svgs/close-icon";

export const ThankYouModal = ({
  onClose,
  title = "Thank you for your request",
  subtitle = "An IMA India representative will be in touch shortly.",
  phone = "+91 1244591200",
  isVisible = false
}) => {
  if (!isVisible) return null;

  return (
    <div styleName="form-overlay" onClick={onClose}>
      <div
        styleName="form-modal thankyou"
        onClick={(e) => e.stopPropagation()}
      >
        <div styleName="form-close" onClick={onClose}>
          <CloseIcon size={12} />
        </div>

        <div styleName="thankyouContainer">
          <div>
            <h2 styleName="thankyou-title">
              {title}
            </h2>
            <p styleName="thankyou-subtitle">
              {subtitle}
            </p>
          </div>

          <p styleName="thankyou-footer">
            *For any other queries please call{" "}
            <span>{phone}</span>
          </p>
        </div>
      </div>
    </div>
  );
};